import * as TY from 'containers/pages/announcementManagement/constants';
import { AnnouncementValidation } from 'containers/pages/announcementManagement/types';

type SetValidFn = (fn: (prev: AnnouncementValidation) => AnnouncementValidation) => void;

function handleAnnouncement(
  e: { target: { name: string; value: string } },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: (action: { type: string; payload: any }) => void,
  setValid: SetValidFn,
) {
  const name = e.target.name.trim();
  const value = e.target.value;

  switch (name) {
    case TY.TITLE:
      dispatch({ type: TY.TITLE, payload: value });
      setValid((prev) => {
        const trimmed = value.trim();
        const isEmpty = !trimmed;
        const tooLong = trimmed.length > 150;
        return {
          ...prev,
          Title: {
            isErr: isEmpty || tooLong,
            errMsg: isEmpty
              ? 'Title is required'
              : tooLong
                ? 'Title must be 150 characters or less'
                : '',
            canNotSave: isEmpty || tooLong,
          },
        };
      });
      break;

    case TY.DESCRIPTION:
      dispatch({ type: TY.DESCRIPTION, payload: value });
      setValid((prev) => {
        const trimmed = value.trim();
        const isEmpty = !trimmed;
        const tooLong = trimmed.length > 2000;
        return {
          ...prev,
          Description: {
            isErr: isEmpty || tooLong,
            errMsg: isEmpty
              ? 'Description is required'
              : tooLong
                ? 'Description must be 2000 characters or less'
                : '',
            canNotSave: isEmpty || tooLong,
          },
        };
      });
      break;

    case TY.EXPIRE_DATE:
      dispatch({ type: TY.EXPIRE_DATE, payload: value });
      setValid((prev) => ({
        ...prev,
        ExpireDate: {
          isErr: !value,
          errMsg: !value ? 'Expire date is required' : '',
          canNotSave: !value,
        },
      }));
      break;

    case TY.MORE_LINK:
      dispatch({ type: TY.MORE_LINK, payload: value });
      break;

    default:
      dispatch({ type: name, payload: value });
      break;
  }
}

export default handleAnnouncement;
